<template>
  <el-form ref="ff" :model="detail" label-width="40px">
    <el-form-item label="名称" prop="Name">
      <el-input v-model="detail.Name" />
    </el-form-item>
    <el-form-item label="编码" prop="Code">
      <el-input v-model="detail.Code" />
    </el-form-item>
    <el-form-item label="序号" prop="Sort">
      <el-input v-model="detail.Sort" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" icon="el-icon-position" @click="onSubmit">提交</el-button>
    </el-form-item>
  </el-form>
</template>


<script>
export default {
  data () {
    return {
      detail: this._detail || {},
    }
  },
  props: {
    _detail: {
      type: Object,
      default: null
    },
    layerid: {
      type: String,
      default: null
    }
  },
  created () {
    if (!this.detail.TypeId) {
      this.$message.error("缺少分类，请先选择分类后操作")
      this.$layer.close(this.layerid)
    }
  },
  methods: {
    //提交数据
    onSubmit () {
      this.$refs["ff"].validate(valid => {
        if (valid) {
          this.$apis.system.meta.itemSave(this.detail).then(() => {
            this.$layer.close(this.layerid)
            this.$parent.loadData()
            this.$message({ message: "数据提交成功！", type: "success" })
          }).catch(e => {
            this.$message.console.error(e || "数据提交失败！")
          })
        }
      })
    }
  }
};
</script>
